import apiClient from './apiClient';

class ProjectService {
  async refreshTicketCount(projectId) {
    try {
      return await apiClient.post(`/projects/${projectId}/refresh_ticket_count`);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to refresh ticket count');
    }
  }
  async refreshTicketCounts(projectIds) {
    try {
      return await apiClient.post('/projects/refresh_ticket_counts', {
        project_ids: projectIds,
      });
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to refresh ticket counts');
    }
  }
  async getProjects() {
    try {
      return await apiClient.get('/projects');
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch projects');
    }
  }

  async getProject(projectId) {
    try {
      return await apiClient.get(`/projects/${projectId}`);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch project');
    }
  }

  async createProject(projectData) {
    try {
      return await apiClient.post('/projects', { project: projectData });
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to create project');
    }
  }

  async updateProject(projectId, projectData) {
    try {
      return await apiClient.patch(`/projects/${projectId}`, { project: projectData });
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || err?.errors?.join(', ') || 'Failed to update project');
    }
  }

  async deleteProject(projectId) {
    try {
      return await apiClient.delete(`/projects/${projectId}`);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to delete project');
    }
  }
}

export const projectService = new ProjectService();